<template>
  <div class="sv sv009">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-green" src="sv009/main.jpg">
        <p class="heading1">いまさら聞けない！ローンの基礎知識</p>
        <h1 class="heading2">ローンにおける金利の<br />仕組みとは？</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-green _pt-sm-50"
        icon-left="sv009/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv009/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人"
      >
        お金を借りようか迷っているものの、ローン未経験のBさん。<br />
        しっかり者の同僚Aさんに相談することにします。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <HeadingTwo class="_mt-md-110 _mt-sm-60">金利、利息ってなに？</HeadingTwo>

      <TalkGroup>
        <TalkBox src="sv009/avatar-b.gif"
          >キャッシングやローンを利用しようと思っているけど、利息はどのくらいかかるのかしら</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >利息は借りる金額と金利をもとに計算するけど…、Bさんは金利や利息って調べたりしてる？</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif"
          >うーん、実はよく分かってなくて…</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >たとえば、DVDを借りるとレンタル料を払うよね。お金も同じで、キャッシングやローンを使ってお金を借りると、借りた金額に加えてお金のレンタル料として利息を払うんだよ。</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif"
          >お金のレンタル料が『利息』ってことなのね</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >そうそう。そして、お金のレンタル料がいくらになるのか計算するときに使うのが『金利』なんだよ</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif"
          >なるほど。金利を調べれば、利息をいくら払うのか計算できるのね！早速調べてみるわ！</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >利用者を守るため、金利の上限が法律で決まっている！</HeadingTwo
      >

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv009/avatar-b.gif"
          >でも、ローンの金利って高いんでしょ？ちゃんと返済できるかな？</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >そう思うかもしれないけど、実は法律で金利の上限が決められているんだ。利用者が安心して利用できるよう、ルール化されているんだよ。</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif">そうなんだ！</TalkBox>
        <TalkBox src="sv009/avatar-a.gif"
          >借り過ぎは禁物だけど、利用者を守る仕組みがあるから、計画的に返せるように借りれば必要以上に心配することはないんだ</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif"
          >わたしたちは法律で守られているんだね！</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-green _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-green" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -green">
            金利の上限は「15％～20％ 」！借入額に応じて法律で決まっている！
          </h3>
        </div>
        <div class="card-body01">
          <div class="card-groups">
            <div class="card-box -width40 order2">
              <div class="card-image">
                <img
                  src="@/assets/images/sv/sv009/img01.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="card-box -width60 _mb-sm-30 _pl-md-60 order1">
              貸金業者は法律で規制されていて、金利の上限などの様々なルールを守らなければ業務停止等の厳しい処分を受けます。
            </div>
          </div>
          <p class="txt01">
            参考元：「公共財団法人
            日本クレジットカウンセリング協会」多重債務Q&A<br /><a
              href="http://www.jcco.or.jp/business/publications/pdf/all.pdf"
              target="_blank"
              >（http://www.jcco.or.jp/business/publications/pdf/all.pdf）</a
            >
          </p>
        </div>
      </ContentsCard>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >利息を計算してみよう！金利15.0％だといくら払うの？</HeadingTwo
      >

      <TalkGroup src="sv009/img02.jpg" class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv009/avatar-b.gif"
          >早速計算してみようかな！借りる金額が4万円で、実質年利が15.0％の場合は…4万円×15.0％だから…、6千円かな？そんなにかかるんだ…！</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >半分正解かな。Bさんの答えは、4万円を1年間借りたときに支払う利息なんだ</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-green _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-green" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -green">金利は1年間の利息の割合のこと！</h3>
        </div>
        <div class="card-body02">
          <p class="txt01">
            金利は年率で表示されますが、利息の計算は日割り計算で行われます。<br />たとえば…
          </p>
          <div class="card-groups _mb-sm-30 _mb-md-40">
            <div class="card-box">
              <div class="card-body">
                4万円を1カ月（30日）で返済すれば、<br />利息は牛丼１杯分！
              </div>
              <div class="triangle-bottom _mb-md-30 _mb-sm-20"></div>
              <div class="card-image">
                <div class="-leftimg _ml-md-30 _mb-sm-15">
                  <img
                    src="@/assets/images/sv/sv009/img03.gif"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="txt01 _mb-sm-20">
                  4万円×15.0%<br class="-spnone" />
                  ÷365日×30日<br />
                  <span class="txt02">=</span
                  ><span class="-primary _ml-5">約</span
                  ><span class="-primary -font">493</span
                  ><span class="-primary">円</span><br />
                  <span class="txt03">お利息</span
                  ><span class="txt04">牛丼約1杯分</span
                  ><span class="txt03">相当</span>
                </div>
              </div>
            </div>
            <div class="card-box">
              <div class="card-body">
                4万円を1週間で返済すれば、<br />利息はジュース1本分！
              </div>
              <div class="triangle-bottom _mb-md-30 _mb-sm-20"></div>
              <div class="card-image">
                <div class="-rightimg _ml-md-80 _mb-sm-15">
                  <img
                    src="@/assets/images/sv/sv009/img04.gif"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="txt01">
                  4万円×15.0%<br class="-spnone" />
                  ÷365日×7日<br />
                  <span class="txt02">=</span
                  ><span class="-primary _ml-5">約</span
                  ><span class="-primary -font">115</span
                  ><span class="-primary">円</span><br />
                  <span class="txt03">お利息</span
                  ><span class="txt04">缶コーヒー約1本分</span
                  ><span class="txt03">相当</span>
                </div>
              </div>
            </div>
          </div>
          <p>
            ※ au PAY
            スマートローンのご返済方式は、「元利均等定額の借入時残高スライドリボルビング方式」となっております。<br />
            上記は一括でご返済いただいた場合の例となります。
          </p>
          <ListGroup class="-note">
            <ListItem class="-note"
              >お借り入れの当日はご利用日数に含まれません</ListItem
            >
            <ListItem class="-note"
              >お利息の計算では、1円未満端数切捨てとなります。</ListItem
            >
            <ListItem class="-note"
              >お借り入れ時がうるう年の場合は366日での計算となります。</ListItem
            >
          </ListGroup>
        </div>
      </ContentsCard>

      <TalkGroup>
        <TalkBox src="sv009/avatar-b.gif"
          >DVDのレンタル料と同じように、お金も早く返せば利息が少なくなるんだね</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >そうなんだ。ローンの返済方法を工夫すれば、利息の負担を減らすことができるんだよ！</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >利息は“お金のレンタル料・使用料”</HeadingTwo
      >

      <TalkGroup class="_mb-30">
        <TalkBox src="sv009/avatar-a.gif"
          >金利や利息の感じ方はそれぞれ違うかもしれないけど、お金のレンタル料と考えれば、利息は妥当な金額なんじゃないかな</TalkBox
        >
        <TalkBox src="sv009/avatar-b.gif"
          >そうかも。それに、利用者は法律で守られているから、心配しすぎなくてもいいってわかったよ</TalkBox
        >
        <TalkBox src="sv009/avatar-a.gif"
          >お金を借りるときは、金利をもとに利息を計算して、ムリのない返済計画を立てるといいよ</TalkBox
        >
      </TalkGroup>

      <ListGroup class="-note _mb-0">
        <ListItem class="-note"
          >au PAY
          スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
        >
      </ListGroup>

      <div class="container">
        <BtngroupSingle class="-margin-lg">
          <btn-main class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</btn-main
          >
        </BtngroupSingle>
      </div>
      <cv-box class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv010" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv010/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンの返済方法やルールとは？</h3>
          </CardHeader>
          <CardBody
            >「お金を借りたらどうやって返すの…？」au PAY
            スマートローンの返済方法についてはこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv011" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv011/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </CardHeader>
          <CardBody
            >借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv012" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv012/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">お金を借りたいけど、周りの人に知られない？</h3>
          </CardHeader>
          <CardBody
            >「ローンのこと気になっていたけど、家族や恋人に知られないかな？」にお答えします。</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";

export default {
  name: "Sv009",
  components: {
    BreadcrumbGroup,
    ListItem,
    ListGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "ローンにおける金利の仕組みとは？｜いまさら聞けない！ローンの基礎知識",
      description:
        "意外と知らないローンの基礎知識！金利や利息について初心者でも分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローン知識,金利",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "いまさら聞けない！ローンの基礎知識",
          routerName: "sv043",
        },
        {
          text: "ローンにおける金利の仕組みとは？",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body01 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      font-size: 12px;
      word-break: break-all;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 14px;
      }
    }
    > .card-groups {
      display: flex;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      @include mq-up(md) {
        justify-content: space-between;
      }
      > .card-box {
        @include mq-down(md) {
          width: 100%;
        }
        @include mq-up(md) {
          width: 30%;
        }
        &.order1 {
          @include mq-down(md) {
            order: 1;
          }
        }
        &.order2 {
          @include mq-down(md) {
            order: 2;
          }
        }
        &.-width40 {
          @include mq-up(md) {
            width: 40%;
          }
        }
        &.-width60 {
          @include mq-up(md) {
            width: 60%;
          }
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
        > .card-body {
          line-height: 24px;
        }
      }
    }
  }
}

.contents-card {
  > .card-body02 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 100px !important;
      padding-right: 100px !important;
    }
    > .txt01 {
      margin-bottom: 25px;
      @include mq-up(md) {
        text-align: center;
      }
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          max-width: 420px;
          width: 100%;
        }
        > .card-body {
          background-color: $light;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 10px;
          border-radius: 10px;
          @include mq-up(md) {
            padding-top: 20px;
            padding-bottom: 20px;
          }
        }
        > .triangle-bottom {
          display: inline-block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 15px 7.5px 0 7.5px;
          border-color: $light transparent transparent transparent;
          display: block;
          margin: 0 auto;
          @include mq-up(md) {
            border-width: 20px 12.5px 0 12.5px;
          }
        }
        > .card-image {
          display: flex;
          align-items: center;
          justify-content: center;
          @include mq-up(md) {
            justify-content: space-between;
          }
          @include mq-down(md) {
            flex-wrap: wrap;
          }
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
          &.-width100-sp {
            @include mq-down(md) {
              max-width: 100%;
            }
          }
          > .-leftimg {
            max-width: 110px;
            width: 100%;
            @include mq-up(md) {
              max-width: 159px;
            }
          }
          > .-rightimg {
            max-width: 45px;
            width: 100%;
            @include mq-up(md) {
              max-width: 65px;
            }
          }
          > .txt01 {
            width: 100%;
            text-align: center;
            font-size: 14px;
            @include mq-up(md) {
              font-size: 18px;
            }
            > .txt02 {
              font-weight: bold;
              position: relative;
              bottom: 5px;
            }
            > .txt03 {
              font-size: 14px;
              @include mq-up(md) {
                font-size: 16px;
              }
            }
            > .txt04 {
              font-size: 16px;
              @include mq-up(md) {
                font-size: 20px;
              }
            }
            > .-primary {
              color: $primary;
            }
            > .-font {
              font-size: 30px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
